import { afterNextRender, Component, computed, DestroyRef, ElementRef, inject, input, viewChild } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'lib-ikp-info-tooltip',
  imports: [NgbTooltip, TranslatePipe],
  templateUrl: './info-tooltip.component.html',
})
export class InfoTooltipComponent {
  private readonly elementRef = inject(ElementRef);
  private readonly destroyRef = inject(DestroyRef);

  tooltipText = input.required<string>();
  buttonId = input<string>();
  category = input<'primary' | 'secondary'>('primary');
  size = input<'md' | 'sm' | 'xs'>('sm');
  placement = input<'top' | 'left' | 'right' | 'bottom' | 'auto'>('auto');
  dataTest = input<string>();

  protected btnCssClasses = computed<string>(() => `btn btn-${this.category()}--dark-blue btn-icon btn-${this.size()}`);

  private tooltip = viewChild<NgbTooltip>('tooltip');

  constructor() {
    afterNextRender(() => {
      const observer = new IntersectionObserver(([entry]) => {
        if (!entry.isIntersecting) {
          this.tooltip()?.close();
        }
      });
      observer.observe(this.elementRef.nativeElement);

      this.destroyRef.onDestroy(() => observer.disconnect());
    });
  }
}
